export default __webpack_public_path__ + "static/news1-13f7317926c37578619a7458c26a2c68.jpg";